import './assets/App.css';
import LakeChart from "./chart/LakeChart";
import Header from "./header/Header";
import InfoSection from "./infoSection/InfoSection";
import ContextAuth from "./context/ContextAuth";

function App() {

    return (
        <div className="App">
            <ContextAuth>
                <Header />

                <LakeChart />

                <InfoSection />
            </ContextAuth>
        </div>
    );
}

export default App;
